/**
 * Linenatura — Wishlist
 * - Almacena handles en localStorage (clave: ln_wishlist_v1)
 * - Botón corazón en cada card → toggle add/remove
 * - Sincroniza estado entre todas las cards de la misma página
 * - Renderiza la wishlist en /pages/favoritos (vía data-wishlist-list)
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'ln_wishlist_v1';
  var EVT_CHANGED = 'ln-wishlist-changed';

  function getList() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) { return []; }
  }
  function saveList(list) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (e) {}
    window.dispatchEvent(new CustomEvent(EVT_CHANGED, { detail: { list: list } }));
  }
  function isIn(handle) { return getList().indexOf(handle) !== -1; }
  function toggle(handle) {
    if (!handle) return false;
    var list = getList();
    var idx = list.indexOf(handle);
    if (idx === -1) {
      list.unshift(handle);
      if (list.length > 100) list = list.slice(0, 100);
      saveList(list);
      return true;
    }
    list.splice(idx, 1);
    saveList(list);
    return false;
  }

  function lang() {
    return (document.documentElement.lang || 'es').slice(0, 2).toLowerCase();
  }
  function L(es, fr, de) {
    var l = lang();
    if (l === 'fr') return fr;
    if (l === 'de') return de;
    return es;
  }

  // Toast (reutilizamos estilos del descuento)
  function toast(msg) {
    var existing = document.querySelector('.ln-discount-toast');
    if (existing) existing.remove();
    var el = document.createElement('div');
    el.className = 'ln-discount-toast';
    el.setAttribute('role', 'status');
    el.textContent = msg;
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('ln-discount-toast--show'); });
    setTimeout(function () { el.classList.remove('ln-discount-toast--show'); }, 2500);
    setTimeout(function () { el.remove(); }, 3000);
  }

  // Sync UI: mark hearts based on storage
  function syncHearts() {
    var hearts = document.querySelectorAll('[data-wishlist-toggle]');
    var list = getList();
    hearts.forEach(function (btn) {
      var h = btn.getAttribute('data-product-handle');
      var on = list.indexOf(h) !== -1;
      btn.classList.toggle('ln-heart--on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on
        ? L('Quitar de favoritos', 'Retirer des favoris', 'Aus Favoriten entfernen')
        : L('Añadir a favoritos', 'Ajouter aux favoris', 'Zu Favoriten hinzufügen'));
    });
  }

  // Heart click delegation
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-product-handle');
    var added = toggle(handle);
    syncHearts();
    toast(added
      ? L('Añadido a favoritos ❤', 'Ajouté aux favoris ❤', 'Zu Favoriten hinzugefügt ❤')
      : L('Quitado de favoritos', 'Retiré des favoris', 'Aus Favoriten entfernt'));
  });

  window.addEventListener(EVT_CHANGED, syncHearts);
  document.addEventListener('DOMContentLoaded', syncHearts);

  // ====== Wishlist page renderer ======
  function fetchProduct(handle) {
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function buildItem(product) {
    var url = product.url || '/products/' + product.handle;
    var img = product.featured_image || (product.images && product.images[0]) || '';
    var imgSrc = (typeof img === 'string' ? img : (img.src || '')).replace(/(\.(?:jpg|jpeg|png|webp|avif))(\?.*)?$/i, '_500x$1$2');
    var price = product.price !== undefined ? formatMoney(product.price) : '';
    var compareAt = product.compare_at_price && product.compare_at_price > product.price
      ? '<s class="ln-recent__compare">' + formatMoney(product.compare_at_price) + '</s>' : '';

    var li = document.createElement('li');
    li.className = 'ln-recent__item ln-wishlist__item';
    li.setAttribute('data-handle', product.handle);
    li.innerHTML =
      '<a href="' + url + '" class="ln-recent__link">' +
      (imgSrc ? '<div class="ln-recent__image"><img src="' + imgSrc + '" alt="' + (product.title || '') + '" loading="lazy"></div>' : '') +
      '<div class="ln-recent__info">' +
      '<h3 class="ln-recent__title">' + (product.title || '') + '</h3>' +
      '<div class="ln-recent__price"><span>' + price + '</span>' + compareAt + '</div>' +
      '</div>' +
      '</a>' +
      '<button type="button" class="ln-wishlist__remove" data-wishlist-toggle data-product-handle="' + product.handle + '" aria-label="' +
        L('Quitar de favoritos', 'Retirer des favoris', 'Aus Favoriten entfernen') + '">' +
        '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" fill="none"/></svg>' +
      '</button>';
    return li;
  }

  function renderWishlistPage() {
    var list = document.querySelector('[data-wishlist-list]');
    if (!list) return;
    var empty = document.querySelector('[data-wishlist-empty]');
    var handles = getList();

    list.innerHTML = '';
    if (!handles.length) {
      if (empty) empty.style.display = '';
      return;
    }
    if (empty) empty.style.display = 'none';

    Promise.all(handles.map(fetchProduct)).then(function (results) {
      results.forEach(function (p) {
        if (!p) return;
        list.appendChild(buildItem(p));
      });
      syncHearts();
    });
  }

  document.addEventListener('DOMContentLoaded', renderWishlistPage);
  window.addEventListener(EVT_CHANGED, renderWishlistPage);
})();
